(function() {
    window.addEventListener('load', function() {
        var processSwiperEl = document.querySelectorAll('.b-process__slider');

        if (processSwiperEl.length > 0) {
            processSwiperEl.forEach(function(el) {
                new Swiper(el, {
                    effect: 'coverflow',
                    grabCursor: true,
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop: true,
                    coverflowEffect: {
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: false,
                    },
                });
            });
        }
    });
})();